import { IntegrationType as ApiIntegrationType } from '@arhs-fleetback/types/entities/common';

export const DmsTypeEnum = {
  Carya: 'Carya',
  Dynamo: 'Dynamo',
  Miles: 'Miles',
  Veact: 'Veact',
  XPower: 'XPower'
} as const;

export type DmsTypeEnum = typeof DmsTypeEnum[keyof typeof DmsTypeEnum];

export const IntegrationScopeEnum = {
  EXTERNAL_WEBHOOK: 'EXTERNAL_WEBHOOK',
  INTERNAL: 'INTERNAL'
} as const;

export type IntegrationScopeEnum = typeof IntegrationScopeEnum[keyof typeof IntegrationScopeEnum];

export const ExternalIntegrationTypeEnum = {
  BODY_SCAN: 'BODY_SCAN',
  CUSTOM_ADVICE: 'CUSTOM_ADVICE',
  TIRE_QUOTE: 'TIRE_QUOTE',
  TIRE_SCAN: 'TIRE_SCAN',
  SH_WORK: 'SH_WORK'
} as const;

export type ExternalIntegrationTypeEnum = typeof ExternalIntegrationTypeEnum[keyof typeof ExternalIntegrationTypeEnum];

export const IntegrationTypeEnum = {
  ...ApiIntegrationType,
  AUTOMATED_DOCUMENT_VALIDATION: 'AUTOMATED_DOCUMENT_VALIDATION'
} as const;

export type IntegrationTypeEnum = typeof IntegrationTypeEnum[keyof typeof IntegrationTypeEnum];

export const PlanetVoTypeEnum = {
  API: 'API',
  FTP: 'FTP'
} as const;

export type PlanetVoTypeEnum = typeof PlanetVoTypeEnum[keyof typeof PlanetVoTypeEnum];

export const DmsIntegrationTypeEnum = {
  DMS_API: 'DMS_API',
  DMS_API_CONNECTOR: 'DMS_API_CONNECTOR',
  DMS_FTP: 'DMS_FTP'
} as const;

export type DmsIntegrationTypeEnum = typeof DmsIntegrationTypeEnum[keyof typeof DmsIntegrationTypeEnum];

export const ServiceHeaderIntegrationEventTypeEnum = {
  CREATE: 'CREATE',
  CLOSE: 'CLOSE',
  DELETE: 'DELETE',
  TEST: 'TEST',
  UPDATE: 'UPDATE'
} as const;

export type ServiceHeaderIntegrationEventTypeEnum = typeof ServiceHeaderIntegrationEventTypeEnum[keyof typeof ServiceHeaderIntegrationEventTypeEnum];

export const ServiceHeaderIntegrationTypeEnum = {
  DMS_API: 'DMS_API',
  DMS_API_CONNECTOR: 'DMS_API_CONNECTOR',
  DMS_FTP: 'DMS_FTP',
  ISPA: 'ISPA',
  KEYLOOP: 'KEYLOOP',
  MECA_PLANNING: 'MECA_PLANNING',
  NEXTLANE: 'NEXTLANE',
  SOFT_NRG: 'SOFT_NRG',
  SOFT_VIG: 'SOFT_VIG'
} as const;

export type ServiceHeaderIntegrationTypeEnum = typeof ServiceHeaderIntegrationTypeEnum[keyof typeof ServiceHeaderIntegrationTypeEnum];

export const WorkIntegrationTypeEnum = {
  DMS_API: 'DMS_API',
  DMS_API_CONNECTOR: 'DMS_API_CONNECTOR',
  DMS_FTP: 'DMS_FTP',
  ISPA: 'ISPA',
  KEYLOOP: 'KEYLOOP',
  MECA_PLANNING: 'MECA_PLANNING',
  NEXTLANE: 'NEXTLANE',
  SOFT_NRG: 'SOFT_NRG',
  SOFT_VIG: 'SOFT_VIG',
  PROOVSTATION: 'PROOVSTATION'
} as const;

export type WorkIntegrationTypeEnum = typeof WorkIntegrationTypeEnum[keyof typeof WorkIntegrationTypeEnum];

export const ProviderTyreQuotationEnum = {
  TWO_TRONIC: 'TWO_TRONIC',
  CA_ROOL: 'CA_ROOL',
} as const;

export type ProviderTyreQuotationEnum = typeof ProviderTyreQuotationEnum[keyof typeof ProviderTyreQuotationEnum];

export const ProviderIntegrationTypeEnum = {
  ...ProviderTyreQuotationEnum,
  EFLEETCON: 'EFLEETCON',
  INSTAVALO: 'INSTAVALO'
} as const;

export const AutomaticDocumentScannerProviderEnum = {
  PXL_VISION: 'PXL_VISION'
} as const;

export type AutomaticDocumentScannerProviderEnum = typeof AutomaticDocumentScannerProviderEnum[keyof typeof AutomaticDocumentScannerProviderEnum];

export const AutomaticDocumentScannerProviderLabelEnum: Record<AutomaticDocumentScannerProviderEnum, string> = {
  PXL_VISION: 'PXL'
};

export type ProviderIntegrationTypeEnum = typeof ProviderIntegrationTypeEnum[keyof typeof ProviderIntegrationTypeEnum];

export const AutomaticPhoneAgentProviderEnum = {
  FLOWLYNE: 'FLOWLYNE'
} as const;

export type AutomaticPhoneAgentProviderEnum = typeof AutomaticPhoneAgentProviderEnum[keyof typeof AutomaticPhoneAgentProviderEnum];

export const AutomaticPhoneAgentProviderLabelEnum: Record<AutomaticPhoneAgentProviderEnum, string> = {
  FLOWLYNE: 'FLOWLYNE'
};

export const AutomaticPhoneAgentProviderMessageEnum: Record<AutomaticPhoneAgentProviderEnum, { id: string; defaultMessage: string }> = {
  FLOWLYNE: { id: 'page.config.dealer_general.integration.phoneAgent.provider.flowlyne', defaultMessage: 'Flowlyne' }
};
